export class Staff {

    public id: number;
    public name: string;
    public pinnum: number;
    public sign: boolean;

}



// WEBPACK FOOTER //
// /home/hihoo/ibilling/attendence/public/src/app/Models/staff.ts